export const fonts = {
  default: 'Figtree, sans-serif',
  outfit: 'Outfit, sans-serif',
}